// export const API_URL = "https://admin.nuvoco.com/api/";
//export const API_URL = "https://nuvoco.com/Nuvoco/API/index.php";
// export const imgUrl = "https://admin.nuvoco.com/";

export const imgUrl = "https://admin.nuvoco.com/";
export const API_URL = "https://admin.nuvoco.com/api/";

// export const imgUrl = "http://nuvoco.local/";
// export const API_URL = "http://nuvoco.local/api/";

// export const imgUrl = "https://nuvoadmin.click4demos.co.in/";
// export const API_URL = "https://nuvoadmin.click4demos.co.in/api/";

// export const API_URL = "https://adminnuvoco.click4demos.co.in/api/";
// export const imgUrl = "https://adminnuvoco.click4demos.co.in/";

export const TRANSLATED_PATHS = [
  "/",
  "/about-us",
  "/our-journey",
  // "/our-journey/v1",
  // "/our-journey/v2",
  // "/our-journey/v3",
  // "/hindi/our-journey/v1",
  // "/hindi/our-journey/v2",
  // "/hindi/our-journey/v3",
  // "/gujarati/our-journey/v1",
  // "/gujarati/our-journey/v2",
  // "/gujarati/our-journey/v3",
  // "/marathi/our-journey/v1",
  // "/marathi/our-journey/v2",
  // "/marathi/our-journey/v3",
  "/quality-and-innovation",
  "/top-cement-company",
  "/ready-mix-concrete",
  "/modern-building-materials",
  "/our-brands",
  "/products/concreto-cement",
  "/products/concreto-uno",
  "/products/double-bull-master-cement",
  "/products/double-bull-ppc",
  "/products/double-bull-psc",
  "/products/nirmax-opc",
  "/products/p-s-c",
  "/products/duraguard-cement",
  "/products/duraguard-microfiber-cement",
  "/products/duraguard-cement-opc",
  // "/products/duraguard-xtra-f2f",
  // "/products/duraguard-xtra-cement",
  "/products/infracem-cement",
  "/products/artiste-bare",
  "/products/artiste-coarse",
  "/products/artiste-engrave",
  "/products/artiste-hue",
  "/products/artiste-lumos",
  "/products/ecodure",
  "/products/ecodure-plus",
  "/products/ecodure-prime",
  "/products/x-con",
  "/products/concreto-agile",
  "/products/concreto-agile-flow",
  "/products/concreto-corrosafe-plus",
  "/products/concreto-cwt-plus",
  "/products/concreto-easyfille",
  "/products/concreto-endura",
  "/products/concreto-fluide",
  "/products/concreto-glyde",
  "/products/concreto-instante",
  "/products/concreto-lente",
  "/products/concreto-permadure",
  "/products/concreto-polibre",
  "/products/concreto-regletherme",
  "/products/concreto-robuste",
  "/products/concreto-steelibre",
  "/products/concreto-xlite",
  "/products/concreto-xlite-structure",
  "/products/instamix",
  "/products/instamix-microne",
  "/products/instamix-mortare",
  "/products/artiste-signature",
  "/products/nuvoco-zero-m-iwc",
  "/products/nuvoco-zero-m-2k",
  "/products/nuvoco-zero-m-multipurpose-latex-expert",
  "/products/nuvoco-zero-m-multipurpose-acrylic-expert",
  "/products/nuvoco-zero-m-tile-cleaner",
  "/products/nuvoco-zero-m-wall-putty",
  "/products/nuvoco-zero-m-dry-plaster",
  "/products/nuvoco-zero-m-dry-concrete",
  "/products/nuvoco-zero-m-block-jointing-mortar",
  "/products/nuvoco-zero-m-cover-block",
  "/products/nuvoco-zero-m-tile-adhesive-t1",
  "/products/nuvoco-zero-m-tile-adhesive-t2",
  "/products/nuvoco-zero-m-tile-adhesive-t3",
  "/products/nuvoco-zero-m-tile-adhesive-t4",
  "/products/nuvoco-zero-m-tile-adhesive-t5",
  "/products/nuvoco-zero-m-epoxy-tile-grout",
  "/products/nuvoco-zero-m-tile-grout",
  "/products/nuvoco-zero-m-roof-shield",
  "/sustainability",
  "/health-and-safety",
  "/life-at-nuvoco",
  "/sitemap",
  // "/english-sitemap.xml",
  "/our-employee-value-proposition",
  "/life-at-nuvoco#awardandrecognition",
  "/media/Press-Releases",
  "/contact-us",
  "/vadrajcement",
  // "/disclaimer",
  "/hindi/",
  "/hindi/about-us",
  "/hindi/our-journey",
  "/hindi/quality-and-innovation",
  "/hindi/top-cement-company",
  "/hindi/ready-mix-concrete",
  "/hindi/modern-building-materials",
  "/hindi/our-brands",
  "/hindi/products/concreto-cement",
  "/hindi/products/concreto-uno",
  "/hindi/products/double-bull-master-cement",
  "/hindi/products/double-bull-ppc",
  "/hindi/products/double-bull-psc",
  "/hindi/products/nirmax-opc",
  "/hindi/products/p-s-c",
  "/hindi/products/duraguard-cement",
  "/hindi/products/duraguard-microfiber-cement",
  "/hindi/products/duraguard-cement-opc",
  // "/hindi/products/duraguard-xtra-f2f",
  // "/hindi/products/duraguard-xtra-cement",
  "/hindi/products/infracem-cement",
  "/hindi/products/artiste-bare",
  "/hindi/products/artiste-coarse",
  "/hindi/products/artiste-engrave",
  "/hindi/products/artiste-hue",
  "/hindi/products/artiste-lumos",
  "/hindi/products/ecodure",
  "/hindi/products/ecodure-plus",
  "/hindi/products/ecodure-prime",
  "/hindi/products/x-con",
  "/hindi/products/concreto-agile",
  "/hindi/products/concreto-agile-flow",
  "/hindi/products/concreto-corrosafe-plus",
  "/hindi/products/concreto-cwt-plus",
  "/hindi/products/concreto-easyfille",
  "/hindi/products/concreto-endura",
  "/hindi/products/concreto-fluide",
  "/hindi/products/concreto-glyde",
  "/hindi/products/concreto-instante",
  "/hindi/products/concreto-lente",
  "/hindi/products/concreto-permadure",
  "/hindi/products/concreto-polibre",
  "/hindi/products/concreto-regletherme",
  "/hindi/products/concreto-robuste",
  "/hindi/products/concreto-steelibre",
  "/hindi/products/concreto-xlite",
  "/hindi/products/concreto-xlite-structure",
  "/hindi/products/instamix",
  "/hindi/products/instamix-microne",
  "/hindi/products/instamix-mortare",
  "/hindi/products/artiste-signature",
  "/hindi/products/nuvoco-zero-m-iwc",
  "/hindi/products/nuvoco-zero-m-tile-bonder",
  "/hindi/products/nuvoco-zero-m-2k",
  "/hindi/products/nuvoco-zero-m-tile-bonder",
  "/hindi/products/nuvoco-zero-m-multipurpose-latex-expert",
  "/hindi/products/nuvoco-zero-m-multipurpose-acrylic-expert",
  "/hindi/products/nuvoco-zero-m-tile-cleaner",
  "/hindi/products/nuvoco-zero-m-wall-putty",
  "/hindi/products/nuvoco-zero-m-dry-plaster",
  "/hindi/products/nuvoco-zero-m-dry-concrete",
  "/hindi/products/nuvoco-zero-m-block-jointing-mortar",
  "/hindi/products/nuvoco-zero-m-cover-block",
  "/hindi/products/nuvoco-zero-m-tile-adhesive-t1",
  "/hindi/products/nuvoco-zero-m-tile-adhesive-t2",
  "/hindi/products/nuvoco-zero-m-tile-adhesive-t3",
  "/hindi/products/nuvoco-zero-m-tile-adhesive-t4",
  "/hindi/products/nuvoco-zero-m-tile-adhesive-t5",
  "/hindi/products/nuvoco-zero-m-tile-glitter",
  "/hindi/products/nuvoco-zero-m-tile-bonder",
  "/hindi/products/nuvoco-zero-m-triple-shield-putty",
  "/hindi/products/nirmax-ppc",
  "/hindi/products/duraguard-f2f",
  "/hindi/products/nuvoco-zero-m-epoxy-tile-grout",
  "/hindi/products/nuvoco-zero-m-tile-grout",
  "/hindi/products/nuvoco-zero-m-roof-shield",
  "/hindi/sustainability",
  "/hindi/health-and-safety",
  "/hindi/life-at-nuvoco",
  "/hindi/our-employee-value-proposition",
  "/hindi/life-at-nuvoco#awardandrecognition",
  "/hindi/media/Press-Releases",
  "/hindi/sitemap",
  "/hindi/contact-us",
  "/hindi/vadrajcement",
  "/hindi/blog/:id",
  "/hindi/disclaimer",
  "/hindi/media/Press-Releases",
  "/gujarati/",
  "/gujarati/about-us",
  "/gujarati/our-journey",
  "/gujarati/quality-and-innovation",
  "/gujarati/top-cement-company",
  "/gujarati/ready-mix-concrete",
  "/gujarati/modern-building-materials",
  "/gujarati/our-brands",
  "/gujarati/products/concreto-cement",
  "/gujarati/products/concreto-uno",
  "/gujarati/products/double-bull-master-cement",
  "/gujarati/products/double-bull-ppc",
  "/gujarati/products/double-bull-psc",
  "/gujarati/products/nirmax-opc",
  "/gujarati/products/p-s-c",
  "/gujarati/products/duraguard-cement",
  "/gujarati/products/duraguard-microfiber-cement",
  "/gujarati/products/duraguard-cement-opc",
  // "/gujarati/products/duraguard-xtra-f2f",
  // "/gujarati/products/duraguard-xtra-cement",
  "/gujarati/products/infracem-cement",
  "/gujarati/products/artiste-bare",
  "/gujarati/products/artiste-coarse",
  "/gujarati/products/artiste-engrave",
  "/gujarati/products/artiste-hue",
  "/gujarati/products/artiste-lumos",
  "/gujarati/products/ecodure",
  "/gujarati/products/ecodure-plus",
  "/gujarati/products/ecodure-prime",
  "/gujarati/products/x-con",
  "/gujarati/products/concreto-agile",
  "/gujarati/products/concreto-agile-flow",
  "/gujarati/products/concreto-corrosafe-plus",
  "/gujarati/products/concreto-cwt-plus",
  "/gujarati/products/concreto-easyfille",
  "/gujarati/products/concreto-endura",
  "/gujarati/products/concreto-fluide",
  "/gujarati/products/concreto-glyde",
  "/gujarati/products/concreto-instante",
  "/gujarati/products/concreto-lente",
  "/gujarati/products/concreto-permadure",
  "/gujarati/products/concreto-polibre",
  "/gujarati/products/concreto-regletherme",
  "/gujarati/products/concreto-robuste",
  "/gujarati/products/concreto-steelibre",
  "/gujarati/products/concreto-xlite",
  "/gujarati/products/concreto-xlite-structure",
  "/gujarati/products/instamix",
  "/gujarati/products/instamix-microne",
  "/gujarati/products/instamix-mortare",
  "/gujarati/products/artiste-signature",
  "/gujarati/products/nuvoco-zero-m-iwc",
  "/gujarati/products/nuvoco-zero-m-2k",
  "/gujarati/products/nuvoco-zero-m-multipurpose-latex-expert",
  "/gujarati/products/nuvoco-zero-m-multipurpose-acrylic-expert",
  "/gujarati/products/nuvoco-zero-m-tile-cleaner",
  "/gujarati/products/nuvoco-zero-m-wall-putty",
  "/gujarati/products/nuvoco-zero-m-dry-plaster",
  "/gujarati/products/nuvoco-zero-m-dry-concrete",
  "/gujarati/products/nuvoco-zero-m-block-jointing-mortar",
  "/gujarati/products/nuvoco-zero-m-cover-block",
  "/gujarati/products/nuvoco-zero-m-tile-adhesive-t1",
  "/gujarati/products/nuvoco-zero-m-tile-adhesive-t2",
  "/gujarati/products/nuvoco-zero-m-tile-adhesive-t3",
  "/gujarati/products/nuvoco-zero-m-tile-adhesive-t4",
  "/gujarati/products/nuvoco-zero-m-tile-adhesive-t5",
  "/gujarati/products/nuvoco-zero-m-epoxy-tile-grout",
  "/gujarati/products/nuvoco-zero-m-tile-grout",
  "/gujarati/products/nuvoco-zero-m-tile-glitter",
  "/gujarati/products/nuvoco-zero-m-tile-bonder",
  "/gujarati/products/nuvoco-zero-m-roof-sgueld",
  "/gujarati/products/nirmax-ppc",
  // "/gujarati/products/duraguard-f2f",
  "/gujarati/products/nuvoco-zero-m-roof-shield",
  "/gujarati/sustainability",
  "/gujarati/sitemap",
  "/gujarati/health-and-safety",
  "/gujarati/life-at-nuvoco",
  "/gujarati/our-employee-value-proposition",
  "/gujarati/life-at-nuvoco#awardandrecognition",
  "/gujarati/media/Press-Releases",
  "/gujarati/contact-us",
  "/gujarati/vadrajcement",
  "/hindi",
  "/gujarati",
  "/nuvoco-zero-m-partner",
  "/hindi/products/nuvoco-zero-m-triple-shield-putty",
  "/gujarati/products/nuvoco-zero-m-triple-shield-putty",
  /* marathi */
  "/marathi",
  "/marathi/",
  "/marathi/about-us",
  "/marathi/our-journey",
  "/marathi/quality-and-innovation",
  "/marathi/top-cement-company",
  "/marathi/ready-mix-concrete",
  "/marathi/modern-building-materials",
  "/marathi/our-brands",
  "/marathi/products/concreto-cement",
  "/marathi/products/concreto-uno",
  "/marathi/products/double-bull-master-cement",
  "/marathi/products/double-bull-ppc",
  "/marathi/products/double-bull-psc",
  "/marathi/products/nirmax-opc",
  "/marathi/products/p-s-c",
  "/marathi/products/duraguard-cement",
  "/marathi/products/duraguard-microfiber-cement",
  "/marathi/products/duraguard-rapidx-cement",
  "/marathi/products/duraguard-xtra-f2f",
  "/marathi/products/duraguard-xtra-cement",
  "/marathi/products/infracem-cement",
  "/marathi/products/artiste-bare",
  "/marathi/products/artiste-coarse",
  "/marathi/products/artiste-engrave",
  "/marathi/products/artiste-hue",
  "/marathi/products/artiste-lumos",
  "/marathi/products/ecodure",
  "/marathi/products/ecodure-plus",
  "/marathi/products/ecodure-prime",
  "/marathi/products/x-con",
  "/marathi/products/concreto-agile",
  "/marathi/products/concreto-agile-flow",
  "/marathi/products/concreto-corrosafe-plus",
  "/marathi/products/concreto-cwt-plus",
  "/marathi/products/concreto-easyfille",
  "/marathi/products/concreto-endura",
  "/marathi/products/concreto-fluide",
  "/marathi/products/concreto-glyde",
  "/marathi/products/concreto-instante",
  "/marathi/products/concreto-lente",
  "/marathi/products/concreto-permadure",
  "/marathi/products/concreto-polibre",
  "/marathi/products/concreto-regletherme",
  "/marathi/products/concreto-robuste",
  "/marathi/products/concreto-steelibre",
  "/marathi/products/concreto-xlite",
  "/marathi/products/concreto-xlite-structure",
  "/marathi/products/instamix",
  "/marathi/products/instamix-microne",
  "/marathi/products/instamix-mortare",
  "/marathi/products/artiste-signature",
  "/marathi/products/nuvoco-zero-m-iwc",
  "/marathi/products/nuvoco-zero-m-2k",
  "/marathi/products/nuvoco-zero-m-multipurpose-latex-expert",
  "/marathi/products/nuvoco-zero-m-multipurpose-acrylic-expert",
  "/marathi/products/nuvoco-zero-m-tile-cleaner",
  "/marathi/products/nuvoco-zero-m-wall-putty",
  "/marathi/products/nuvoco-zero-m-dry-plaster",
  "/marathi/products/nuvoco-zero-m-dry-concrete",
  "/marathi/products/nuvoco-zero-m-block-jointing-mortar",
  "/marathi/products/nuvoco-zero-m-cover-block",
  "/marathi/products/nuvoco-zero-m-tile-adhesive-t1",
  "/marathi/products/nuvoco-zero-m-tile-adhesive-t2",
  "/marathi/products/nuvoco-zero-m-tile-adhesive-t3",
  "/marathi/products/nuvoco-zero-m-tile-adhesive-t4",
  "/marathi/products/nuvoco-zero-m-tile-adhesive-t5",
  "/marathi/products/nuvoco-zero-m-epoxy-tile-grout",
  "/marathi/products/nuvoco-zero-m-tile-grout",
  "/marathi/products/nuvoco-zero-m-tile-glitter",
  "/marathi/products/nuvoco-zero-m-tile-bonder",
  "/marathi/products/nuvoco-zero-m-roof-sgueld",
  "/marathi/products/nirmax-ppc",
  "/marathi/products/duraguard-f2f",
  "/marathi/products/nuvoco-zero-m-roof-shield",
  "/marathi/sustainability",
  "/marathi/sitemap",
  "/marathi/health-and-safety",
  "/marathi/life-at-nuvoco",
  "/marathi/our-employee-value-proposition",
  "/marathi/life-at-nuvoco#awardandrecognition",
  "/marathi/media/Press-Releases",
  "/marathi/contact-us",
  "/marathi/vadrajcement",
  "/marathi/products/nuvoco-zero-m-triple-shield-putty",
  "/marathi/products/duraguard-cement-opc"
];
